import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiSelectCheckboxComponent } from './multi-select-checkbox.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    MultiSelectCheckboxComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    MultiSelectCheckboxComponent
  ]
})
export class MultiSelectCheckboxModule { }
